/*!
 * WatchTender 銀座 — 時計用語辞典 ホバーポップオーバー (watch-glossary-hover-1.js)
 * ------------------------------------------------------------------------
 * 商品説明文中に自動リンクされた用語 (.wtg-term-link) にマウスを載せると、
 * 単語の横に辞典の解説を吹き出しで表示します。辞典ページへは遷移しません。
 *
 *  - ホバー可能な端末 : マウスを載せる → 約0.2秒後に表示 / 離すと自動で閉じる
 *                       クリックすると「固定」され、外側クリックか Esc まで開いたまま
 *  - タッチ端末       : タップで表示 / 外側タップで閉じる
 *  - キーボード       : Tab でフォーカスしても表示 / Esc で閉じる
 *
 * 読み込み順： watch-glossary-index-N.js → watch-glossary-autolink-N.js → 本ファイル
 * 用語データ (watch-glossary-terms-5.js / 約314KB) は先読みのうえ遅延読み込みします。
 */
(function () {
  'use strict';

  /* ==== 設定 ====================================================== */
  var CONFIG = {
    // 用語データファイル。terms-6.js 等に更新したらここだけ差し替える
    dataUrl: '/cdn/shop/files/watch-glossary-terms-5.js',
    // ポップオーバー下部に「用語辞典で見る →」リンクを出すか
    showGlossaryLink: true,
    // ポップアップ化する対象。本文中に自動リンクされた用語のみ。
    // ブランド枠の「時計用語百科事典で見る →」(.wt-brand-m) は
    // 辞典ページへ誘導するCTAなので、従来どおり遷移させる。
    match: 'a.wtg-term-link',
    // 表示までの待ち時間(ms)。文章の上をマウスが素通りしただけで出ないようにする
    openDelay: 220,
    // 単語と吹き出しの間をマウスが横切る猶予(ms)
    closeDelay: 200,
    // 吹き出しの最大幅(px)
    width: 360
  };
  /* ================================================================ */

  if (window.WTGH_READY) return;
  window.WTGH_READY = true;

  var LANG = (document.documentElement.getAttribute('lang') || 'ja').toLowerCase();
  var LG = LANG.indexOf('ja') === 0 ? 'ja'
         : LANG.indexOf('zh') === 0 ? 'zh'
         : LANG.indexOf('ko') === 0 ? 'ko' : 'en';

  var ROOT = (function () {
    try {
      var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return r.replace(/\/+$/, '');
    } catch (e) {
      return { ja: '', en: '/en', zh: '/zh', ko: '/ko' }[LG] || '';
    }
  })();
  var PAGE = ROOT + '/pages/watch-glossary';
  var SEL = CONFIG.match;

  // ホバーできる端末か（スマホ・タブレットは false → タップ動作になる）
  var HOVER = (function () {
    try { return window.matchMedia('(hover: hover) and (pointer: fine)').matches; }
    catch (e) { return !('ontouchstart' in window); }
  })();

  /* ---- カテゴリラベル（用語辞典ページと同一） ---- */
  var CATS = {
    ja: { brand:'ブランド', movement:'ムーブメント・機構', complication:'複雑機構', 'case':'ケース・外装', dial:'文字盤・針', crystal:'風防', band:'ベルト・ブレス', material:'素材・仕上げ', parts:'部品', standard:'精度・規格', vintage:'状態・ヴィンテージ', trade:'取引・流通', history:'歴史・背景' },
    en: { brand:'Brands', movement:'Movements & mechanics', complication:'Complications', 'case':'Case & exterior', dial:'Dial & hands', crystal:'Crystals', band:'Straps & bracelets', material:'Materials & finishing', parts:'Components', standard:'Accuracy & standards', vintage:'Condition & vintage', trade:'Trade & market', history:'History & background' },
    zh: { brand:'品牌', movement:'机芯・机构', complication:'复杂功能', 'case':'表壳・外装', dial:'表盘・指针', crystal:'表镜', band:'表带・表链', material:'材质・修饰', parts:'零件', standard:'精度・规格', vintage:'品相・古董', trade:'交易・流通', history:'历史・背景' },
    ko: { brand:'브랜드', movement:'무브먼트・기구', complication:'컴플리케이션', 'case':'케이스・외장', dial:'다이얼・핸즈', crystal:'글라스', band:'스트랩・브레이슬릿', material:'소재・마감', parts:'부품', standard:'정확도・규격', vintage:'상태・빈티지', trade:'거래・유통', history:'역사・배경' }
  }[LG];

  var T = {
    ja: { rel:'関連する用語', loading:'読み込み中…', more:'用語辞典で見る', err:'解説を読み込めませんでした。', close:'閉じる' },
    en: { rel:'Related terms', loading:'Loading…', more:'Open in the glossary', err:'Could not load this entry.', close:'Close' },
    zh: { rel:'相关术语', loading:'加载中…', more:'在术语词典中查看', err:'无法加载该词条。', close:'关闭' },
    ko: { rel:'관련 용어', loading:'불러오는 중…', more:'용어사전에서 보기', err:'설명을 불러오지 못했습니다.', close:'닫기' }
  }[LG];

  /* ---- スタイル ---------------------------------------------------
     display / width / height に !important を付けている箇所は、テーマ側の
     「div:empty { display:none }」ルールで矢印などが消えるのを防ぐため。     */
  var CSS = [
    '.wtgh-pop{position:fixed;z-index:100000;top:0;left:0;box-sizing:border-box;',
      'width:', CONFIG.width, 'px;max-width:calc(100vw - 24px);max-height:62vh;overflow:auto;-webkit-overflow-scrolling:touch;',
      'background:#fff;border-radius:14px;padding:18px 20px 16px;',
      'box-shadow:0 14px 40px rgba(18,48,44,.20),0 2px 6px rgba(18,48,44,.10);',
      'border:1px solid rgba(18,48,44,.10);',
      'font-family:-apple-system,BlinkMacSystemFont,"Hiragino Sans","Hiragino Kaku Gothic ProN","Noto Sans JP","Yu Gothic",sans-serif;',
      'color:#1C3735;text-align:left;opacity:0;transform:translateY(4px);transition:opacity .14s ease-out,transform .14s ease-out;',
      '--ink:#12302C;--gold:#C4A864;--line:rgba(18,48,44,.13);--body:#1C3735;--mute:rgba(28,55,53,.62)}',
    '.wtgh-pop[hidden]{display:none}',
    '.wtgh-pop.is-in{opacity:1;transform:none}',
    '@media (prefers-reduced-motion:reduce){.wtgh-pop{transition:none}}',
    '.wtgh-arrow{position:absolute;width:11px!important;height:11px!important;display:block!important;',
      'background:#fff;border:1px solid rgba(18,48,44,.10);transform:rotate(45deg)}',
    '.wtgh-arrow.is-below{top:-6px;margin-left:-6px;border-right:0;border-bottom:0}',
    '.wtgh-arrow.is-above{bottom:-6px;margin-left:-6px;border-left:0;border-top:0}',
    // 縦書き本文用：単語の左右に出したときの矢印
    '.wtgh-arrow.is-right{left:-6px;margin-top:-6px;border-right:0;border-top:0}',
    '.wtgh-arrow.is-left{right:-6px;margin-top:-6px;border-left:0;border-bottom:0}',
    '.wtgh-cat{margin:0 0 4px;font-size:10.5px;letter-spacing:.16em;color:var(--gold)}',
    '.wtgh-ja{margin:0;font-size:19px;line-height:1.4;font-weight:600;color:var(--ink);',
      'font-family:"Hiragino Mincho ProN","Yu Mincho","Noto Serif JP",serif;outline:none}',
    '.wtgh-meta{margin:5px 0 0;font-size:11.5px;color:var(--mute);line-height:1.6}',
    '.wtgh-en{display:block;font-size:12px;letter-spacing:.05em;color:var(--body);margin-top:1px}',
    '.wtgh-def{margin:12px 0 0;font-size:13.5px;line-height:1.95}',
    '.wtgh-block{margin-top:14px;padding-top:12px;border-top:1px solid var(--line)}',
    '.wtgh-h3{margin:0 0 8px;font-size:10.5px;letter-spacing:.14em;color:var(--mute);font-weight:600}',
    '.wtgh-rel{display:flex;flex-wrap:wrap;gap:5px}',
    '.wtgh-chip{border:1px solid var(--line);background:rgba(255,255,255,.72);color:var(--body);border-radius:999px;',
      'padding:4px 11px;font-size:11.5px;cursor:pointer;font-family:inherit;transition:.16s;white-space:nowrap}',
    '.wtgh-chip:hover{border-color:var(--gold);color:var(--ink)}',
    '.wtgh-more{display:inline-block;margin-top:14px;font-size:11.5px;color:var(--mute);text-decoration:none;',
      'border-bottom:1px dotted var(--line)}',
    '.wtgh-more:hover{color:var(--ink);border-bottom-color:var(--gold)}',
    '.wtgh-state{margin:0;padding:14px 0;font-size:13px;color:var(--mute);text-align:center}',
    // タッチ端末では閉じるボタンを出す（指では「離す」操作ができないため）
    '.wtgh-close{position:absolute;top:8px;right:10px;border:0;background:none;font-size:22px;line-height:1;',
      'color:var(--mute);cursor:pointer;padding:0 4px;display:none}',
    '.wtgh-pop.is-touch .wtgh-close{display:block}',
    '.wtgh-pop.is-touch{padding-top:22px}'
  ].join('');

  function injectCSS() {
    if (document.getElementById('wtgh-style')) return;
    var s = document.createElement('style');
    s.id = 'wtgh-style';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ---- 用語データ（遅延読み込み） ---- */
  var BYJA = null, loading = false, waiters = [], failed = false;

  function indexData() {
    var d = window.WT_GLOSSARY;
    if (!d || !d.length) return false;
    BYJA = {};
    for (var i = 0; i < d.length; i++) if (d[i] && d[i].ja) BYJA[d[i].ja] = d[i];
    return true;
  }
  function flush(ok) { var l = waiters; waiters = []; for (var i = 0; i < l.length; i++) l[i](ok); }
  function ensureData(cb) {
    if (BYJA) return cb(true);
    if (indexData()) return cb(true);
    if (failed) return cb(false);
    waiters.push(cb);
    if (loading) return;
    loading = true;
    var s = document.createElement('script');
    s.src = CONFIG.dataUrl; s.async = true;
    s.onload = function () { loading = false; var ok = indexData(); if (!ok) failed = true; flush(ok); };
    s.onerror = function () { loading = false; failed = true; flush(false); };
    document.head.appendChild(s);
  }

  /* ---- ポップオーバー構築 ---- */
  var pop, arrow, elCat, elJa, elYomi, elEn, elDef, elRelWrap, elRel, elMore, elState, elBody;
  var anchor = null, pinned = false, openT = 0, closeT = 0, rafId = 0;

  function build() {
    injectCSS();
    pop = document.createElement('div');
    pop.className = 'wtgh-pop';
    pop.id = 'wtgh-pop';
    pop.hidden = true;
    pop.setAttribute('role', 'dialog');

    arrow = document.createElement('div');
    arrow.className = 'wtgh-arrow is-below';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'wtgh-close';
    close.setAttribute('aria-label', T.close);
    close.innerHTML = '&times;';
    close.addEventListener('click', function () { hide(true); });

    elState = document.createElement('p'); elState.className = 'wtgh-state';
    elCat = document.createElement('p'); elCat.className = 'wtgh-cat';
    elJa = document.createElement('h2'); elJa.className = 'wtgh-ja'; elJa.tabIndex = -1;
    var meta = document.createElement('p'); meta.className = 'wtgh-meta';
    elYomi = document.createElement('span');
    elEn = document.createElement('span'); elEn.className = 'wtgh-en';
    meta.appendChild(elYomi); meta.appendChild(elEn);
    elDef = document.createElement('p'); elDef.className = 'wtgh-def';

    elRelWrap = document.createElement('div'); elRelWrap.className = 'wtgh-block';
    var h3 = document.createElement('h3'); h3.className = 'wtgh-h3'; h3.textContent = T.rel;
    elRel = document.createElement('div'); elRel.className = 'wtgh-rel';
    elRelWrap.appendChild(h3); elRelWrap.appendChild(elRel);

    elMore = document.createElement('a'); elMore.className = 'wtgh-more'; elMore.textContent = T.more + ' →';

    elBody = document.createElement('div');
    elBody.appendChild(elCat); elBody.appendChild(elJa); elBody.appendChild(meta);
    elBody.appendChild(elDef); elBody.appendChild(elRelWrap);
    if (CONFIG.showGlossaryLink) elBody.appendChild(elMore);

    pop.appendChild(arrow); pop.appendChild(close);
    pop.appendChild(elState); pop.appendChild(elBody);
    document.body.appendChild(pop);

    // 関連用語チップ
    pop.addEventListener('click', function (e) {
      var n = e.target;
      while (n && n !== pop) {
        if (n.classList && n.classList.contains('wtgh-chip')) {
          e.preventDefault();
          pinned = true;
          render(n.getAttribute('data-wtgh-term'));
          position();
          return;
        }
        n = n.parentNode;
      }
    });
  }

  function setState(msg) {
    elState.textContent = msg || '';
    elState.style.display = msg ? '' : 'none';
    elBody.style.display = msg ? 'none' : '';
  }

  function headOf(t) {
    return LG === 'ja' ? t.ja
         : LG === 'zh' ? (t.headZh || t.en || t.ja)
         : LG === 'ko' ? (t.headKo || t.en || t.ja)
         : (t.en || t.ja);
  }
  function defOf(t) {
    return LG === 'zh' ? (t.defZh || t.defEn || t.def)
         : LG === 'ko' ? (t.defKo || t.defEn || t.def)
         : LG === 'en' ? (t.defEn || t.def)
         : t.def;
  }

  function render(ja) {
    var t = BYJA && BYJA[ja];
    if (!t) { setState(T.err); return; }
    setState('');
    elCat.textContent = CATS[t.cat] || '';
    elJa.textContent = headOf(t);
    pop.setAttribute('aria-label', headOf(t));
    elYomi.textContent = LG === 'ja' ? (t.yomi || '') : t.ja;
    elEn.textContent = LG === 'en' ? '' : (t.en || '');
    elDef.textContent = defOf(t) || '';

    elRel.innerHTML = '';
    var rels = (t.rel || []).filter(function (r) { return BYJA[r]; });
    for (var i = 0; i < rels.length; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wtgh-chip';
      b.setAttribute('data-wtgh-term', rels[i]);
      b.textContent = LG === 'ja' ? rels[i] : headOf(BYJA[rels[i]]);
      elRel.appendChild(b);
    }
    elRelWrap.style.display = rels.length ? '' : 'none';
    elMore.href = PAGE + '?term=' + encodeURIComponent(t.ja);
    pop.scrollTop = 0;
  }

  /* ---- 位置決め ---- */
  function position() {
    if (!anchor || pop.hidden) return;
    var r = anchor.getBoundingClientRect();
    // 単語が画面外へ出たら閉じる
    if (r.bottom < 0 || r.top > window.innerHeight) { hide(true); return; }

    var pw = pop.offsetWidth, ph = pop.offsetHeight;
    var vw = document.documentElement.clientWidth, vh = window.innerHeight;
    var M = 12, GAP = 10;
    var left, top, side;

    // 縦書き本文（背が高く幅の狭い単語）は、下ではなく左右に出したほうが自然。
    // ただし横に収まる余白があるときだけ。狭い画面では通常どおり上下に出す。
    var roomR = vw - r.right - GAP - M;
    var roomL = r.left - GAP - M;
    var vertical = r.height > r.width * 1.6 && r.height > 40 &&
                   (roomR >= pw || roomL >= pw);

    if (vertical) {
      var toRight = (roomR >= pw) && (roomR >= roomL || roomL < pw);
      left = toRight ? (r.right + GAP) : (r.left - pw - GAP);
      side = toRight ? 'is-right' : 'is-left';
      top = r.top + r.height / 2 - ph / 2;
    } else {
      left = r.left + r.width / 2 - pw / 2;
      var below = r.bottom + GAP, above = r.top - ph - GAP;
      var useBelow = (below + ph <= vh - M) || (above < M);
      top = useBelow ? below : above;
      side = useBelow ? 'is-below' : 'is-above';
    }

    var clampedL = Math.max(M, Math.min(left, vw - pw - M));
    var clampedT = Math.max(M, Math.min(top, vh - ph - M));
    pop.style.left = Math.round(clampedL) + 'px';
    pop.style.top = Math.round(clampedT) + 'px';

    arrow.className = 'wtgh-arrow ' + side;
    if (vertical) {
      arrow.style.left = '';
      var ay = r.top + r.height / 2 - clampedT;
      arrow.style.top = Math.round(Math.max(18, Math.min(ay, ph - 18))) + 'px';
      // 画面端に寄せた結果、単語から離れすぎたら矢印は隠す
      arrow.style.display = Math.abs(clampedL - left) < 2 ? '' : 'none';
    } else {
      arrow.style.top = '';
      var ax = r.left + r.width / 2 - clampedL;
      arrow.style.left = Math.round(Math.max(18, Math.min(ax, pw - 18))) + 'px';
      arrow.style.display = Math.abs(clampedT - top) < 2 ? '' : 'none';
    }
  }

  function show(a) {
    if (!pop) build();
    anchor = a;
    // ブラウザ標準のツールチップ(title)が二重に出ないよう退避
    var ttl = a.getAttribute('title');
    if (ttl) { if (!a.getAttribute('aria-label')) a.setAttribute('aria-label', ttl); a.removeAttribute('title'); }
    a.setAttribute('aria-describedby', 'wtgh-pop');
    if (!HOVER) pop.classList.add('is-touch');

    pop.hidden = false;
    var term = termOf(a);
    if (BYJA || indexData()) { render(term); }
    else {
      setState(T.loading);
      ensureData(function (ok) {
        if (pop.hidden || anchor !== a) return;
        if (!ok || !BYJA[term]) { setState(T.err); position(); return; }
        render(term); position();
      });
    }
    position();
    // 次フレームでフェードイン
    requestAnimationFrame(function () { if (!pop.hidden) pop.classList.add('is-in'); });
  }

  function hide(force) {
    if (!pop || pop.hidden) return;
    if (pinned && !force) return;
    pinned = false;
    pop.classList.remove('is-in');
    pop.hidden = true;
    if (anchor) anchor.removeAttribute('aria-describedby');
    anchor = null;
  }

  function scheduleOpen(a) {
    if (anchor === a && !pop.hidden) return;
    clearTimeout(openT);
    openT = setTimeout(function () { show(a); }, CONFIG.openDelay);
  }
  function cancelOpen() { clearTimeout(openT); }
  function scheduleClose() {
    clearTimeout(closeT);
    closeT = setTimeout(function () { hide(false); }, CONFIG.closeDelay);
  }
  function cancelClose() { clearTimeout(closeT); }

  /* ---- 対象リンクの判定 ---- */
  function closestLink(node) {
    while (node && node !== document) {
      if (node.nodeType === 1 && node.matches && node.matches(SEL)) return node;
      node = node.parentNode;
    }
    return null;
  }
  function inPop(node) { return !!(pop && node && pop.contains(node)); }

  function termOf(a) {
    if (a.getAttribute('data-term')) return a.getAttribute('data-term');
    var h = a.getAttribute('href') || '';
    var m = /[?&]term=([^&#]*)/.exec(h);
    if (!m) return '';
    try { return decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { return m[1]; }
  }

  /* ---- ホバー ---- */
  if (HOVER) {
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType === 'touch') return;
      var a = closestLink(e.target);
      if (a) { cancelClose(); scheduleOpen(a); return; }
      if (inPop(e.target)) { cancelClose(); cancelOpen(); }
    }, true);

    document.addEventListener('pointerout', function (e) {
      if (e.pointerType === 'touch') return;
      var fromLink = closestLink(e.target), fromPop = inPop(e.target);
      if (!fromLink && !fromPop) return;
      var to = e.relatedTarget;
      if (to && (closestLink(to) === anchor || inPop(to))) return;
      cancelOpen();
      scheduleClose();
    }, true);
  }

  /* ---- クリック／タップ ---- */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = closestLink(e.target);
    if (a) {
      e.preventDefault();
      cancelOpen(); cancelClose();
      pinned = false;
      if (anchor === a && pop && !pop.hidden) { pinned = true; return; }
      show(a);
      pinned = true;   // クリックで固定 → 外側クリックか Esc まで開いたまま
      return;
    }
    if (inPop(e.target)) return;
    hide(true);
  }, false);

  /* ---- キーボード ---- */
  document.addEventListener('focusin', function (e) {
    var a = closestLink(e.target);
    if (a) { cancelClose(); pinned = true; show(a); }
    else if (!inPop(e.target)) hide(true);
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.keyCode === 27) && pop && !pop.hidden) {
      var a = anchor;
      hide(true);
      if (a && a.blur) a.blur();
    }
  });

  /* ---- スクロール・リサイズ追従 ---- */
  function reflow() {
    if (rafId) return;
    rafId = requestAnimationFrame(function () { rafId = 0; position(); });
  }
  window.addEventListener('scroll', reflow, true);
  window.addEventListener('resize', reflow);

  /* ---- 用語データの先読み（表示を待たせない） ---- */
  var primed = false;
  function prime() { if (primed) return; primed = true; ensureData(function () {}); }
  document.addEventListener('pointerover', function (e) {
    if (!primed && closestLink(e.target)) prime();
  }, true);
  (window.requestIdleCallback || function (f) { return setTimeout(f, 2000); })(function () {
    if (document.querySelector(SEL)) prime();
  });
})();
